'use strict';

const light = {
    paper: {
        minWidth: "160px",
        top: "60px",
        marginTop: "5px",
        "&ul": {
            padding: "0px",
        },
    },
};

var MuiPopover = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiPopover = MuiPopover;
exports.light = light;
